import { useState } from 'react';
import { api } from '../api';
import { HONEYPOT_FIELD, HONEYPOT_HIDDEN_STYLE } from '../honeypot';

export function PlaceClaimForm(props: { placeId: string; onDone: () => void }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [note, setNote] = useState('');
  const [fax, setFax] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        setBusy(true);
        setErr('');
        try {
          await api.postJson('/shop-place-claims', { place_id: props.placeId, claimant_name: name, claimant_email: email, claimant_phone: phone, verification_note: note, [HONEYPOT_FIELD]: fax });
          props.onDone();
        } catch {
          setErr('Something went wrong sending your claim. Please try again.');
        } finally {
          setBusy(false);
        }
      }}
    >
      <label htmlFor="pclaim-name">Your name</label>
      <input id="pclaim-name" required value={name} onChange={(e) => setName(e.target.value)} />
      <label htmlFor="pclaim-email">Email</label>
      <input id="pclaim-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
      <label htmlFor="pclaim-phone">Phone (optional)</label>
      <input id="pclaim-phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
      <label htmlFor="pclaim-note">How can we verify this is yours?</label>
      <textarea id="pclaim-note" required minLength={5} value={note} onChange={(e) => setNote(e.target.value)} />
      {/* honeypot — hidden from people, irresistible to bots */}
      <div aria-hidden="true" style={HONEYPOT_HIDDEN_STYLE}>
        <label htmlFor="pclaim-fax">Fax number</label>
        <input id="pclaim-fax" name={HONEYPOT_FIELD} tabIndex={-1} autoComplete="off" value={fax} onChange={(e) => setFax(e.target.value)} />
      </div>
      {err && (
        <p className="error" role="alert">
          {err}
        </p>
      )}
      <button className="primary" type="submit" disabled={busy}>
        Send claim request
      </button>
    </form>
  );
}
